"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var odc_text_1 = __importDefault(require("@tencent/odc-text"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_1 = require("@tencent/spaui");
var SwitchGroup = function SwitchGroup(props) {
  var _a = props.tip,
    tip = _a === void 0 ? '' : _a,
    className = props.className,
    _b = props.label,
    label = _b === void 0 ? '' : _b,
    _c = props.checked,
    checked = _c === void 0 ? false : _c,
    _d = props.checkedLabel,
    checkedLabel = _d === void 0 ? '' : _d,
    _e = props.unCheckedLabel,
    unCheckedLabel = _e === void 0 ? '' : _e,
    _f = props.hideCheckedLabel,
    hideCheckedLabel = _f === void 0 ? false : _f,
    _g = props.checkedTips,
    checkedTips = _g === void 0 ? '' : _g,
    // 开启后附加
    checkedAddon = props.checkedAddon,
    // 关闭后附加
    uncheckedAddon = props.uncheckedAddon,
    // 常驻附加
    commonAddon = props.commonAddon,
    size = props.size,
    switchProps = __rest(props, ["tip", "className", "label", "checked", "checkedLabel", "unCheckedLabel", "hideCheckedLabel", "checkedTips", "checkedAddon", "uncheckedAddon", "commonAddon", "size"]);
  var switchText = label;
  // 如果有设置选中或不选中的对应文案，就替换下
  if (checked) {
    if (checkedLabel) {
      switchText = checkedLabel;
    }
  } else {
    if (unCheckedLabel) {
      switchText = unCheckedLabel;
    }
  }
  return react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('switch-group', className, {
      checked: checked
    })
  }, react_1["default"].createElement(spaui_1.Switch, __assign({
    size: size,
    checked: checked,
    tips: tip
  }, switchProps)), !hideCheckedLabel ? react_1["default"].createElement(odc_text_1["default"], {
    type: "primary",
    className: "ml-8 switch-text",
    label: switchText
  }) : null, checkedTips && checked ? react_1["default"].createElement(odc_text_1["default"], {
    type: 'highlight',
    size: 'small',
    className: "switch-tips"
  }, checkedTips) : null, checked ? checkedAddon : uncheckedAddon, commonAddon);
};
exports["default"] = SwitchGroup;